/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useEffect} from 'react';
import './SceneSelection.scss';

import {currentGameInfoQuery, currentSceneInfoQuery} from '../recoil/selectors';
import {SCENE_SCREEN} from '../recoil/state';
import {getImagePath} from '../Helper';
import {useSetRecoilState, useRecoilValue} from 'recoil';
import {
  currentSceneIDState,
  currentScreenState, previousSceneIDState,
  sceneHistoryQueueState,
} from '../recoil/atoms';

import { useMediaQuery } from 'react-responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';


function SceneSelection() {
  const currentScene = useRecoilValue(currentSceneInfoQuery);
  const setCurrentSceneID = useSetRecoilState(currentSceneIDState);
  const setPreviousSceneID = useSetRecoilState(previousSceneIDState);
  const setCurrentScreen = useSetRecoilState(currentScreenState);
  const currentGame = useRecoilValue(currentGameInfoQuery);
  const setSceneHistoryQueue = useSetRecoilState(sceneHistoryQueueState);

  const isMobile = useMediaQuery({ maxWidth: 575 });
  const isLandscape = useMediaQuery({ orientation: 'landscape', maxWidth: 850});

  useEffect(() => {
    if (currentScene.choices.length === 1) {
      console.log(currentScene.choices[0].linkToScene);
      console.log(currentGame.tree.id);
    }
  }, [currentScene]);

  const handleSceneChoice = (choice) => {
    setPreviousSceneID(setCurrentSceneID);
    setCurrentSceneID(choice.linkToScene);
    setCurrentScreen(SCENE_SCREEN);
    setSceneHistoryQueue(state => [choice.linkToScene, ...state]);
  };

  return (
    <div className="interactive-player">
      <div className="player-next-steps  d-flex justify-content-center align-items-center">
        <div className="d-flex flex-column align-items-center player-next-steps--inner">
          <h2 className={`text-center player-next-steps__header ${isLandscape ? '--landscape' : 'mb-4'}`}>{currentScene.title.length > 0 ? currentScene.title : `WHAT DO YOU WANT TO DO HERE?`}</h2>
          <div className={`carousel-wrapper ${isLandscape ? 'isLandscape' : ''}`}>
            {/*RENDER SLIDER ON MOBILE*/}
            {  (
                ((currentScene.choices.length > 2) && !isLandscape) ||
                ((currentScene.choices.length > 3) && isLandscape) ||
                ((isMobile && !isLandscape) && currentScene.choices.length > 1)) && (
                <CarouselProvider
                    naturalSlideWidth={100}
                    naturalSlideHeight={isLandscape ? 140 : 100}
                    isIntrinsicHeight={true}
                    totalSlides={currentScene.choices.length}
                    visibleSlides={
                      function(){
                        if (isLandscape) {
                          return 3;
                        }  else if (isMobile){
                          return 1
                        } else {
                          return 2;
                        }
                      }()
                    }
                    orientation={'horizontal'}
                >
                  <ButtonBack>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </ButtonBack>
                  <Slider>
                    { currentScene.choices.map((choice, index) => {
                        return (
                            <Slide className='player-step' key={index} index={index}>
                              <Choice choice={choice} handleSelection={handleSceneChoice}/>
                            </Slide>
                        )
                    })}
                  </Slider>
                  <ButtonNext>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </ButtonNext>
                </CarouselProvider>
            )}

            {/*RENDER DESKTOP STEPS (NO SLIDER)*/}
            { (
                ((currentScene.choices.length <= 2) && !isMobile) ||
                ((currentScene.choices.length <= 3) && isLandscape) ||
                (currentScene.choices.length <= 1 && isMobile))  && (
                <div className="d-flex justify-content-center non-carousel">
                { currentScene.choices.map((choice, index) => {
                    return (
                        <div className='player-step' key={index}>
                          <Choice choice={choice} handleSelection={handleSceneChoice}/>
                        </div>
                    )
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function Choice({choice, handleSelection}) {
  const currentGame = useRecoilValue(currentGameInfoQuery);
  const imageUrl = getImagePath(choice.poster, currentGame.site, currentGame.shootId);
  return (
      <a className="link-button d-block"  onClick={() => handleSelection(choice)}>
        <img src={imageUrl} className="w-100" alt={choice.title}/>
        <div className="bottom">
          <p className="player-step__text">{choice.title}</p>
        </div>
      </a>
  )
}

export default SceneSelection;


